"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var _LinkRaw = _interopRequireDefault(require("../LinkRaw"));

var _RadioRaw = _interopRequireDefault(require("../RadioRaw"));

var __jsx = _react["default"].createElement;

function Selectable$(props) {
  var disabled = props.disabled,
      highlighted = props.highlighted,
      selected = props.selected,
      label = props.label,
      invalid = props.invalid,
      sx = props.sx,
      as = props.as,
      children = props.children,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      onSelect = props.onSelect,
      _props$ignoreLabel = props.ignoreLabel,
      ignoreLabel = _props$ignoreLabel === void 0 ? false : _props$ignoreLabel,
      id = props.id,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["disabled", "highlighted", "selected", "label", "invalid", "sx", "as", "children", "onFocus", "onBlur", "onSelect", "ignoreLabel", "id"]);

  var _useState = (0, _react.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  if (!label && ignoreLabel === false) {
    console.warn("You didn't pass label prop to the Selectable. This will affect accessibility negatively.");
  }

  var state = (0, _objectSpread2["default"])({}, props);
  var content = children(state);
  var radioRef = (0, _react.useRef)(null);

  if (as === "link") {
    return (0, _.jsx)(_LinkRaw["default"], (0, _extends2["default"])({
      title: label,
      sx: (0, _objectSpread2["default"])({
        $resetFocus: true,
        display: "block"
      }, css),
      onFocus: function onFocus(e) {
        setFocused(true);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);

        if (_onBlur) {
          _onBlur(e);
        }
      },
      id: id
    }, restProps), content);
  }

  if (as === "radio") {
    return (0, _.jsx)(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        display: "block",
        position: "relative",
        cursor: "pointer"
      }, css),
      onClick: function onClick() {
        if (disabled) {
          return;
        }

        radioRef.current.focus();

        if (onSelect) {
          onSelect();
        }
      },
      className: focused ? "__commui_focus" : ""
    }, (0, _.jsx)("label", {
      htmlFor: id,
      sx: {
        visibility: "hidden",
        position: "absolute"
      }
    }, label), (0, _.jsx)(_RadioRaw["default"], (0, _extends2["default"])({}, restProps, {
      id: id,
      onFocus: function onFocus(e) {
        setFocused(true);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);

        if (_onBlur) {
          _onBlur(e);
        }
      },
      checked: selected,
      disabled: disabled,
      onChange: function onChange() {
        if (onSelect) {
          onSelect();
        }
      },
      inputRef: radioRef
    })), content);
  }

  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({
      display: "block",
      position: "relative",
      cursor: disabled ? "not-allowed" : "pointer"
    }, css)
  }, restProps), content);
}

var _default = Selectable$;
exports["default"] = _default;